import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  ref: "container",
  class: "time-picker"
}
const _hoisted_2 = { class: "input-group" }
const _hoisted_3 = ["disabled", "value"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-clock" })
  ])
], -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("input", {
        ref: "input",
        type: "text",
        class: "form-control",
        disabled: _ctx.disabled,
        maxlength: 8,
        value: _ctx.modelValue,
        autocomplete: "off"
      }, null, 8 /* PROPS */, _hoisted_3),
      _hoisted_4
    ])
  ], 512 /* NEED_PATCH */))
}